/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';

/* rakuten */
// import ClientMonitor from '@sixthsense/sixthsense-javascript-agent'; 
// import { AppConst } from './app/app.constants';


// const collector = ClientMonitor.register({
//   service: AppConst.RAKUTEN_SERVICE_NAME, // Name the app
//   collector: AppConst.RAKUTEN_COLLECTOR, // Provided by the Onboarding team
//   pagePath: 'index.html',
//   serviceVersion: AppConst.RAKUTEN_SERVICE_VERSION,
//   enableSPA: true,
//   useFmp: true,
//   autoTracePerf: true,
//   detailMode: true,
//   environment: AppConst.ENV_VARIABLE,
//   authorization: AppConst.RAKUTEN_AUTH,
//   enableDistributedTracing: true,
// });

// ClientMonitor.setPerformance({
//   service: AppConst.RAKUTEN_SERVICE_NAME,
//   collector: AppConst.RAKUTEN_COLLECTOR,
//   serviceVersion: AppConst.RAKUTEN_SERVICE_VERSION,
//   perfInterval: 1000,
//   useFmp: true,
//   authorization: AppConst.RAKUTEN_AUTH,
// });

/* rakuten */

// enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
